import { render, staticRenderFns } from "./ERC777.vue?vue&type=template&id=be4b50fa&"
import script from "./ERC777.vue?vue&type=script&lang=js&"
export * from "./ERC777.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports